<template>
    <mysearch></mysearch>
</template>
<script>
import mysearch from "@/components/search/search";
export default {
   components: {
     mysearch,
  },
   data () {
      return {}
     },
     methods: {}
}
</script>
<style  scoped>
</style>



// WEBPACK FOOTER //
// src/pages/search/search.vue